module.exports = __webpack_public_path__ + "img/P8-en.abcd454a.png";